import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const FOTOS = [
    { src: "/photos/hero.jpg", judul: "Signature di tangan", catatan: "Espresso, creamer, brown sugar, susu" },
    { src: "/photos/matcha.jpg", judul: "Matcha Latte", catatan: "Matcha premium di atas buku VOGUE" },
    { src: "/photos/bottles.jpg", judul: "Bottled 250ml & Seliter", catatan: "Bawa pulang, simpan dingin" },
    { src: "/photos/dispensers.jpg", judul: "Sudut racik", catatan: "Syrup dispenser & seliter siap kirim" },
    { src: "/photos/shop-interior.jpg", judul: "Dalam cafe", catatan: "Teman ngopi yang hangat" },
    { src: "/photos/shop-exterior.jpg", judul: "Etalase depan", catatan: "Slow down, you're doing fine" },
    { src: "/photos/galeri-promo.jpg", judul: "Promo Signature", catatan: "Coffee signature 10K — cek IG untuk yang terbaru" },
    { src: "/photos/galeri-suasana.jpg", judul: "Suasana cafe", catatan: "Sudut favorit buat foto bareng" },
    { src: "/photos/galeri-pelanggan.jpg", judul: "Pelanggan ngomongin", catatan: "Signature-nya bikin angkat tangan" },
    { src: "/photos/galeri-hello.jpg", judul: "Hello, welcome!", catatan: "Sampai jumpa di cafe — buka setiap hari" },
];

export default function Galeri() {
    return (
        <div className="pt-24 lg:pt-32" data-testid="galeri-page">
            <header className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal>
                    <span className="eyebrow">Cuplikan cafe</span>
                </Reveal>
                <div className="mt-4 flex flex-wrap items-end justify-between gap-6">
                    <Reveal delay={0.08}>
                        <h1 className="font-display text-5xl font-extrabold tracking-tighter text-ink sm:text-6xl lg:text-7xl">
                            Galeri.
                        </h1>
                    </Reveal>
                    <Reveal delay={0.16}>
                        <p className="max-w-md pb-2 text-sm leading-relaxed text-ink-muted">
                            Semua foto asli dari cafe — diambil dari Instagram{" "}
                            <a
                                href="https://instagram.com/yuhuku.kopi"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="galeri-link-instagram"
                                className="font-semibold text-accent hover:underline"
                            >
                                @yuhuku.kopi
                            </a>
                            . Mampir dulu biar fotonya nggak cuma lewat layar.
                        </p>
                    </Reveal>
                </div>
            </header>

            <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
                <div className="columns-2 gap-5 sm:columns-3 [column-fill:balance]">
                    {FOTOS.map((f, i) => (
                        <Reveal key={f.src} delay={(i % 3) * 0.06} className="mb-5 break-inside-avoid">
                            <figure
                                data-testid={`galeri-item-${i + 1}`}
                                className="group overflow-hidden rounded-[2rem] border border-ink/5 bg-white shadow-soft transition-shadow duration-300 hover:shadow-lift"
                            >
                                <div className="overflow-hidden">
                                    <img
                                        src={f.src}
                                        alt={f.judul}
                                        loading="lazy"
                                        className="w-full object-cover transition-transform duration-500 group-hover:scale-105"
                                    />
                                </div>
                                <figcaption className="px-5 py-4">
                                    <p className="font-display text-sm font-bold tracking-tight text-ink">
                                        {f.judul}
                                    </p>
                                    <p className="mt-0.5 text-xs text-ink-muted">{f.catatan}</p>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>

                <Reveal>
                    <div className="mt-12 flex flex-wrap items-center justify-between gap-4 rounded-3xl border border-ink/5 bg-white px-6 py-5 shadow-soft sm:px-8">
                        <p className="font-semibold text-ink">
                            Foto kamu bareng kopinya? Tag{" "}
                            <span className="text-accent">@yuhuku.kopi</span> — bisa
                            muncul di sini.
                        </p>
                        <Link
                            to="/kontak"
                            data-testid="galeri-cta-kontak"
                            className="btn-primary"
                        >
                            Kirim Pesan <ArrowRight className="h-4 w-4" />
                        </Link>
                    </div>
                </Reveal>
            </div>
        </div>
    );
}